import { TActivityLogStyles, VendorMetaItem } from "@elixir/types";
import { GET_TRYST_HOST } from "../constants/env";
import fetch from "../fetch-client";
import { TrystGenericResponse } from "../types/tryst";

export default async function getAppointmentLogsStyles({
  aid,
}: {
  aid: string;
}): Promise<
  TrystGenericResponse<TActivityLogStyles[]> & AppointmentActivityMeta
> {
  try {
    const TRYST_HOST = GET_TRYST_HOST();
    const myHeaders = new Headers();

    const requestOptions: RequestInit = {
      method: "GET",
      headers: myHeaders,
      redirect: "follow",
      mode: "cors",
      credentials: "include",
    };

    const response = await fetch(
      `${TRYST_HOST}/appointment/${aid}/activity/log/styles?source=MIXPANEL`,
      requestOptions
    );
    return await response.json();
  } catch (error) {
    console.error(error);
    return {
      success: false,
      meta: {
        vendor_meta: [],
      },
    };
  }
}

export type AppointmentActivityMeta = {
  meta?: {
    vendor_meta: VendorMetaItem[];
  };
};
